import { t_status } from '../types/event_type';
import { EventSourceStream } from './ess';

export type t_codex_code = number | string;
export type t_codex_id = string;
export type t_uri = string;

export type t_codex_category = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export type TIssueCodex = TIssue & { reason: string; status: string };
export type TIssue = { code: number; context: Record<string, number | string | boolean> };
export type TCodexDB = { id: t_codex_id; db: TCodex };
export type TCodex = Record<t_codex_code, string>;

// @todo replace with f1.template
// this can happen when we fully move to ess loading as a module
const es6Var = /\${(.*?)}/g;

export class Codex {
  private __ess: EventSourceStream;

  /**
   * the lowest value for an issue of that type
   */
  readonly watermark: Record<t_status, t_codex_category> = {
    success: 1,
    info: 2,
    warning: 4,
    failure: 6,
    fatal: 8
  };

  /**
   * map codex code to status name
   */
  readonly statusCode: Record<t_codex_category, t_status> = {
    1: 'success',
    2: 'info',
    3: 'info',
    4: 'warning',
    5: 'warning',
    6: 'failure',
    7: 'failure',
    8: 'fatal',
    9: 'fatal'
  };

  /**
   * link codex to ess
   */
  link(ess: EventSourceStream) {
    this.__ess = ess;
    return this;
  }

  /**
   * read an issue from a codex
   * @param codexId
   * @param codexIssue
   *
   * @todo replace with f1.template
   * this can happen when we fully move to ess loading as a module
   */
  read(codexDB: TCodexDB, issue: TIssue) {
    const template = codexDB.db[issue.code];
    const vars = issue.context;

    return template.replace(es6Var, (_: string, k: string) => `${vars[k]}`);
  }

  /**
   * lookup the status name for a codex code
   * @param codexCode
   *
   * @example code(1030) becomes info
   * @example code(9123) becomes fatal
   */
  status(codexCode: t_codex_code) {
    return this.statusCode[this.__codeToBracket(codexCode)];
  }

  private __codeToBracket(codexCode: t_codex_code) {
    return (Number.parseInt(`${codexCode}`, 10) / 1000) | 0;
  }

  /**
   *
   * @param codexPath the folder path to "codex.json". Do not include "codex.json"
   * @return a promise with the codexId inside
   */
  process(codexDB: TCodexDB, issues: TIssue[]): TIssueCodex[] {
    return issues.map((issue) => {
      return {
        ...issue,
        reason: this.read(codexDB, issue),
        status: this.status(issue.code)
      };
    });
  }
}
